import { Link } from "react-router-dom";
import { useState } from "react";
import { Plus, Minus } from "lucide-react";

const FAQ = [
  { q: "À quelle fréquence faut-il nettoyer mes panneaux ?", a: "Nous préconisons une intervention annuelle, idéalement après la saison des pollens (mai/juin) afin de maximiser la production estivale." },
  { q: "Devez-vous monter sur mon toit ?", a: "Dans 90 % des cas, non. Nos perches en fibre de carbone permettent d'intervenir jusqu'à 15 m depuis le sol." },
  { q: "Puis-je nettoyer moi-même avec mon jet d'eau ?", a: "Ce n'est pas conseillé. Le choc thermique peut fissurer les cellules, et le calcaire de l'eau de ville crée un dépôt qui salit plus vite." },
  { q: "Le nettoyage est-il rentable ?", a: "Oui. Sur une installation standard, le gain de production couvre largement le coût et préserve la garantie constructeur." },
  { q: "Utilisez-vous des produits chimiques ?", a: "Non. Uniquement de l'eau pure osmosée, neutre et biodégradable." },
  { q: "Combien de temps dure une intervention ?", a: "Pour 10 à 20 panneaux, comptez 1 à 2 heures." },
];

export default function Expertise() {
  return (
    <div data-testid="expertise-page">
      <section className="section pt-16">
        <div className="container-x max-w-3xl">
          <p className="tag">Expertise technique</p>
          <h1 className="text-[40px] md:text-[52px] leading-[1.1] font-bold text-[#0F1A2A]">
            Pourquoi l'eau pure osmosée ?
          </h1>
          <p className="mt-6 text-[17px] text-[#1F2A3D]">
            L'eau du robinet contient du calcaire et des minéraux qui, en séchant au soleil,
            cristallisent et créent un voile blanc sur le verre. Ce voile opacifie les
            panneaux et accélère le réencrassement.
          </p>
          <p className="mt-4 text-[17px] text-[#1F2A3D]">
            Notre station d'osmose inverse filtre l'eau jusqu'à un niveau de pureté proche de
            <strong> 0 ppm</strong>. Cette eau attire les salissures comme un solvant naturel,
            sans rayer et sans laisser de résidu. <strong>C'est le seul traitement validé par
            les fabricants de panneaux.</strong>
          </p>
          <p className="mt-4 text-[17px] text-[#1F2A3D]">
            Grâce à nos perches télescopiques en fibre de carbone, nous intervenons depuis le
            sol jusqu'à 15 m. Aucun poids n'est exercé sur votre toiture, ce qui préserve les
            tuiles et l'étanchéité.
          </p>
        </div>
      </section>

      <section className="section bg-[#F6F4EF] border-t border-[#E6E4DF]">
        <div className="container-x max-w-3xl">
          <p className="tag">Le danger invisible</p>
          <h2 className="h-title">Le hotspot</h2>
          <p className="mt-5 text-[#1F2A3D]">
            Une simple tache de fiente crée une zone de résistance électrique. La cellule
            obstruée surchauffe (plus de 100 °C) tandis que les autres produisent. Ce
            déséquilibre thermique peut fissurer le verre ou brûler le circuit interne.
          </p>
          <p className="mt-4 text-[#1F2A3D]">
            Les mousses qui colonisent les cadres attaquent aussi les joints en silicone, ce
            qui crée des risques d'infiltrations sous votre toit. Un nettoyage annuel prévient
            ce risque d'incendie et de panne définitive.
          </p>
        </div>
      </section>

      <section className="section border-t border-[#E6E4DF]">
        <div className="container-x max-w-3xl">
          <p className="tag">Questions fréquentes</p>
          <h2 className="h-title mb-8">Vos questions, nos réponses</h2>

          <div className="divide-y divide-[#E6E4DF] border-y border-[#E6E4DF]">
            {FAQ.map((item) => <FAQItem key={item.q} {...item} />)}
          </div>

          <div className="mt-10">
            <Link to="/contact" data-testid="faq-cta" className="link-accent">Une autre question ? Contactez-nous →</Link>
          </div>
        </div>
      </section>
    </div>
  );
}

function FAQItem({ q, a }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="py-4">
      <button
        data-testid="faq-toggle"
        onClick={() => setOpen((o) => !o)}
        className="w-full flex items-center justify-between gap-4 text-left py-2"
      >
        <span className="font-medium text-[#0F1A2A]">{q}</span>
        {open ? <Minus size={18} className="text-[#6B7280]" /> : <Plus size={18} className="text-[#6B7280]" />}
      </button>
      {open && <p className="text-[#1F2A3D] text-[15px] pt-2 pb-2 max-w-2xl">{a}</p>}
    </div>
  );
}
